module.exports = __webpack_public_path__ + "static/img/14m.d80b475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14m.jpg
// module id = 461W
// module chunks = 0